module.exports = __webpack_public_path__ + "static/media/bullet-footerNav.990c965b.svg";